import { render, staticRenderFns } from "./projectsWarranty.vue?vue&type=template&id=4bc5976d&scoped=true"
import script from "./projectsWarranty.vue?vue&type=script&lang=js"
export * from "./projectsWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5976d",
  null
  
)

export default component.exports